/**
 * Stock "por ingresar" en las cotizaciones (2026-11-02). Cotizar contra lo que
 * viene en camino está permitido (`calcStockCotizable`), pero el vendedor tiene
 * que verlo: celeste = depende de stock por ingresar, rojo = no alcanza ni así.
 */

export type EstadoStock = 'normal' | 'por-ingresar' | 'sin-stock';

/** Estado de una cantidad acumulada (la de la línea y las anteriores del mismo artículo). */
export function estadoPorCantidad(disponible: number, porIngresar: number, cantidad: number): EstadoStock {
  const disp = Math.max(0, disponible);
  if (cantidad > disp + Math.max(0, porIngresar)) return 'sin-stock';
  if (cantidad > disp) return 'por-ingresar';
  return 'normal';
}

/** Estado de la próxima unidad que se agregaría, dado lo ya cotizado del artículo. */
export function estadoSiguienteUnidad(disponible: number, porIngresar: number, usado: number): EstadoStock {
  return estadoPorCantidad(disponible, porIngresar, usado + 1);
}

/**
 * Estado de cada línea según el orden en que se cargaron: las primeras toman
 * el Disponible y las que lo pasan dependen de lo por ingresar.
 */
export function estadosPorLinea<L extends { key: string; articuloId: string; cantidad: number }>(
  lines: L[],
  stockDe: (articuloId: string) => { disponible: number; porIngresar: number },
): Map<string, EstadoStock> {
  const acumulado = new Map<string, number>();
  const out = new Map<string, EstadoStock>();
  for (const l of lines) {
    const hasta = (acumulado.get(l.articuloId) ?? 0) + l.cantidad;
    acumulado.set(l.articuloId, hasta);
    const { disponible, porIngresar } = stockDe(l.articuloId);
    out.set(l.key, estadoPorCantidad(disponible, porIngresar, hasta));
  }
  return out;
}

/** Clases del ítem del picker (rojo sin stock, celeste por ingresar). */
export const CLASE_ITEM_SIN_STOCK = 'bg-rose-50 text-rose-900 hover:bg-rose-100 focus-visible:bg-rose-100';
export const CLASE_ITEM_POR_INGRESAR = 'bg-sky-50 text-sky-900 hover:bg-sky-100 focus-visible:bg-sky-100';
